/**
 * Scripts
 * 
 */

document.addEventListener('DOMContentLoaded', initialize);

function initialize() {
  fixHeader();
  toggleMenu();
  toggleSearchModal();
}

/**
 * Fix Header when scroll
 * 
 */
function fixHeader() {
  const header = document.getElementById('header');

  function handler(entries, observer) {
    for (let entry of entries) {
      if (entry.isIntersecting) {
        header.classList.remove('fixed');
      } else {
        header.classList.add('fixed');
      }
    }
  }
  
  const observer = new IntersectionObserver(handler);
  observer.observe(document.getElementsByClassName('menu-aux')[0]);
}

/**
 * Toggle Main Menu
 * 
 */
function toggleMenu() {
  const menu = document.getElementById('menu');
  const menuOpen = document.querySelector('.js-menu-open');
  const menuClose = document.querySelector('.js-menu-close');
  const openClass = 'open';
  const hiddenClass = 'no-scroll';
  const body = document.body;

  if (menuOpen !== null) {
    menuOpen.onclick = function() {
      menu.classList.toggle(openClass);

      if (body.classList.contains(hiddenClass)) {
        body.classList.remove(hiddenClass);
      } else {
        body.classList.add(hiddenClass);
      }

      return false;
    }

    menuClose.onclick = function() {
      menu.classList.remove(openClass);
      body.classList.remove(hiddenClass);

      return false;
    }
  }
}


/**
 * Toggle Search Modal
 * 
 */
function toggleSearchModal() {
  const search = document.getElementById('search-modal');
  const searchOpen = document.querySelector('.js-search-open');
  const searchClose = document.querySelector('.js-search-close');
  const openClass = 'open';
  const hiddenClass = 'no-scroll';
  const body = document.body;

  if (searchOpen !== null) {
    searchOpen.onclick = function() {
      search.classList.toggle(openClass);

      /*if (body.classList.contains(hiddenClass)) {
        body.classList.remove(hiddenClass);
      } else {
        body.classList.add(hiddenClass);
      }*/

      return false;
    }

    searchClose.onclick = function() {
      search.classList.remove(openClass);
      // body.classList.remove(hiddenClass);

      return false;
    }
  }
}
